var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kanban-task"},[_c('div',{staticClass:"kanban-task__header"},[_vm._v(_vm._s(_vm.task.title))]),_c('div',{staticClass:"kanban-task__description"},[_vm._v(_vm._s(_vm.task.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }